/*eslint-disable*/
import IntervalConfig from './IntervalConfig';

export default {
    seconds: IntervalConfig.secondsForAddAndSub,
    digits: IntervalConfig.digits,
    timeLimitValues: IntervalConfig.timeLimitValues
}
